import request from '@/common/request'
const book = {
	// 信息提交
	getContact: params => request.post(`/official/rest/visitor/v1/contact`,params),
	//订单查询
	getOreder: params => request.post(`/official/rest/nft/v1/search`,params),
}

export default book  